"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attribution = void 0;
const typescript_json_serializer_1 = require("typescript-json-serializer");
const kochava_1 = require("./kochava"); // Import the Kochava model
let Attribution = class Attribution {
    constructor(kochava) {
        this.kochava = kochava;
    }
};
__decorate([
    (0, typescript_json_serializer_1.JsonProperty)({ type: kochava_1.Kochava }),
    __metadata("design:type", kochava_1.Kochava)
], Attribution.prototype, "kochava", void 0);
Attribution = __decorate([
    (0, typescript_json_serializer_1.JsonObject)(),
    __metadata("design:paramtypes", [kochava_1.Kochava])
], Attribution);
exports.Attribution = Attribution;
